/**
 * Pre-pack label location. The control's printer is the carton label (4x6 at 203 DPI).
 * Box labels are resolved on the server from this station and the label stock:
 * FI-5A-W is 4x4 at 300 DPI, FI-3C and FI-5A are 3.5x4 at 300 DPI, assigned ABB PDD is 4x6 at 203 DPI.
 */

export { ZPL_PRINTER_STORAGE_KEYS } from "@/lib/zplPrinter";

import { ZPL_PRINTER_STORAGE_KEYS } from "@/lib/zplPrinter";
import { useZplPrintLocation } from "@/lib/zplPrintLocation";

export const PREPACK_ZPL_PRINTER_STORAGE_KEY = ZPL_PRINTER_STORAGE_KEYS.prepack;

export function usePrepackZplPrinter(): ReturnType<typeof useZplPrintLocation> {
  return useZplPrintLocation({
    storageKey: ZPL_PRINTER_STORAGE_KEYS.prepack,
    documents: [
      { id: "carton", label: "Carton", labelSize: "4x6", dpi: 203 },
      { id: "box-4x4", label: "Box 4x4", labelSize: "4x4", dpi: 300 },
      { id: "box-3.5x4", label: "Box 3.5x4", labelSize: "3.5x4", dpi: 300 },
    ],
  });
}
